import { render, staticRenderFns } from "./CodeMng.vue?vue&type=template&id=98b0454a&scoped=true"
import script from "./CodeMng.vue?vue&type=script&lang=js"
export * from "./CodeMng.vue?vue&type=script&lang=js"
import style0 from "./CodeMng.vue?vue&type=style&index=0&id=98b0454a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b0454a",
  null
  
)

export default component.exports